import { Component, OnInit } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ApisService } from '../../services/apis.service';
import { ElectronService } from '../../services/electron.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(
    private apiService: ApisService,
    private electron: ElectronService,
  ) { }

  isLoggedIn: Object|Boolean = false;
  fixtureDate: any;
  courseName: any;
  isElectron: Boolean = this.electron.isElectron();

  ngOnInit() {
    this.apiService.observableFixture.subscribe(data => {
      this.courseName = data.courseName;
      this.fixtureDate = data.fixtureDate;
    });

    this.apiService.observableLoggedIn.subscribe(data => {
      if(data.user_id !== null)
        this.isLoggedIn = true;
      else
        this.isLoggedIn = false;
    });
  }

  resetFixture() {
    this.apiService.changeFixtureData({index: null, courseName: null, fixtureDate: null});
  }

  quit() {
    this.electron.closeApplication();
  }

  logout() {
    this.apiService.logout();
  }

}
